import { hFetch } from '@/lib/hfetch';
import type { HResponse } from '@/lib/hfetch/types';
import type { ScheduledActionEntity } from './entity_types/ScheduledAction';

type SendScheduledEmailArgs = {
  contactId: number;
  invokeOn: string;
  subject: string;
  body: string;
  files?: FileList | null;
};

type SendScheduledMessageArgs = {
  contactId: number;
  invokeOn: string;
  body: string;
};

export const cancelScheduledAction = async (id: number): Promise<HResponse<ScheduledActionEntity>> => {
  const response = await hFetch<ScheduledActionEntity, { status: string }>({
    url: `/api/scheduled_actions/${id}`,
    method: 'DELETE',
  });
  if (response.status === 'error') throw new Error(response.messages.join(', '));

  return response;
};

export const createScheduledEmail = async (args: SendScheduledEmailArgs) => {
  const formData = new FormData();
  formData.append('action_type', 'send_email');
  formData.append('assigned_for_contact_id', String(args.contactId));
  formData.append('invoke_on', args.invokeOn);
  formData.append('subject', args.subject);
  formData.append('body', args.body);

  if (args.files) {
    for (let i = 0; i < args.files.length; i++) {
      formData.append('files[]', args.files[i], args.files[i].name);
    }
  }

  return await createScheduledAction(formData);
};

export const createScheduledMessage = async (args: SendScheduledMessageArgs) => {
  const formData = new FormData();
  formData.append('action_type', 'send_sms');
  formData.append('assigned_for_contact_id', String(args.contactId));
  formData.append('invoke_on', args.invokeOn);
  formData.append('body', args.body);

  return await createScheduledAction(formData);
};

const createScheduledAction = async (payload: FormData): Promise<HResponse<ScheduledActionEntity>> => {
  return await hFetch<ScheduledActionEntity, FormData>({
    url: '/api/scheduled_actions',
    method: 'POST',
    payload,
  });
};
